import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { UserStatus } from 'types/schema-generated-types';
import UserStatusHeader from '../../../components/UserStatusHeader';

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      paddingBottom: theme.spacing(3)
    }
  };
});

interface UserInformationHeaderProps {
  userId: number;
  avatarUrl?: string | null | undefined;
  firstName?: string;
  lastName?: string;
  userStatus?: UserStatus;
}

const UserInformationHeader: React.FC<UserInformationHeaderProps> = ({
  avatarUrl,
  firstName,
  lastName,
  userStatus
}) => {
  const classes = useStyles();

  return (
    <Grid container direction="row" wrap="nowrap" className={classes.root}>
      <UserStatusHeader
        avatarUrl={avatarUrl || ''}
        firstName={firstName || ''}
        lastName={lastName || ''}
        userStatus={userStatus}
      />
    </Grid>
  );
};

export default UserInformationHeader;
